import React from 'react';
import { Card, Space, Typography, List, Tag, Badge, Skeleton, Empty, Button, Tooltip } from 'antd';
import { AlertOutlined, WarningOutlined, SearchOutlined, CreditCardOutlined, ShieldOutlined, DownloadOutlined } from '@ant-design/icons';
import { motion } from 'framer-motion';

const { Text } = Typography;

const AnomalyAlerts = ({ loading, data = [], onExport }) => {
  // Mapeamento dos dados da API para o formato visual do componente
  const anomalies = data.map(item => ({
    title: 'Saldo de Caixa Negativo',
    description: `Detectado saldo de caixa inconsistente no mês ${item.mes}.`,
    empresa: item.cliente?.nomeFantasia || item.cliente?.nome || `ID: ${item.cliente?.id}`,
    codigo_empresa: item.cliente?.id,
    valor: item.valorNegativo,
    count: 1,
    level: item.status?.toLowerCase() === 'crítico' ? 'critical' : 'warning',
    icon: <WarningOutlined />,
    color: item.status?.toLowerCase() === 'crítico' ? '#ef4444' : '#f59e0b',
    bg: item.status?.toLowerCase() === 'crítico' ? '#fef2f2' : '#fffbeb',
    border: item.status?.toLowerCase() === 'crítico' ? '#fee2e2' : '#fef3c7'
  }));

  return (
    <Card
      title={
        <Space>
          <AlertOutlined style={{ color: '#ef4444', fontSize: 18 }} />
          <span style={{ fontWeight: 800 }}> Auditoria Contínua</span>
        </Space>
      }
      bordered={false}
      style={{ borderRadius: 24, boxShadow: '0 4px 20px rgba(0,0,0,0.03)', height: '100%', minHeight: 480 }}
      extra={
        <Space>
          {onExport && (
            <Tooltip title="Exportar alertas">
              <Button
                type="text"
                icon={<DownloadOutlined style={{ fontSize: 16 }} />}
                onClick={onExport}
                style={{ color: '#64748b' }}
              />
            </Tooltip>
          )}
          <Badge count={data.length} style={{ backgroundColor: '#ef4444' }} />
        </Space>
      }
    >
      {loading ? (
        <Skeleton active paragraph={{ rows: 10 }} />
      ) : anomalies.length === 0 ? (
        <div style={{ height: '350px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Empty description="Nenhum alerta detectado no momento" />
        </div>
      ) : (
        <div style={{ paddingRight: '8px', maxHeight: '400px', overflowY: 'auto' }}>
          <List
            dataSource={anomalies}
            pagination={{
              pageSize: 15,
              size: 'small',
              hideOnSinglePage: true,
              style: { textAlign: 'center', marginTop: 16 }
            }}
            renderItem={(item, index) => (
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <List.Item style={{ padding: '16px 0', borderBottom: '1px dashed #e2e8f0' }}>
                  <div style={{ display: 'flex', width: '100%', gap: 16, alignItems: 'flex-start' }}>

                    <div style={{
                      width: 44,
                      height: 44,
                      borderRadius: 12,
                      background: item.bg,
                      border: `1px solid ${item.border}`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: item.color,
                      flexShrink: 0
                    }}>
                      {item.icon}
                    </div>

                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 4 }}>
                        <Text strong style={{ fontSize: 14, color: '#0f172a', display: 'block' }}>{item.title}</Text>
                      </div>
                      <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 8, lineHeight: 1.4 }}>
                        {item.description}
                      </Text>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Text strong style={{ fontSize: 11, color: item.color }}>
                          Empresa: {item.codigo_empresa} - {item.empresa}
                        </Text>
                        <Text strong style={{ fontSize: 12, color: '#ef4444' }}>
                          {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.valor)}
                        </Text>
                      </div>
                    </div>
                  </div>
                </List.Item>
              </motion.div>
            )}
          />
        </div>
      )}
    </Card>
  );
};

export default AnomalyAlerts;

